var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulateDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46839 6.96936C2.53806 6.89952 2.62082 6.8441 2.71194 6.80629C2.80305 6.76849 2.90074 6.74902 2.99939 6.74902C3.09804 6.74902 3.19572 6.76849 3.28684 6.80629C3.37796 6.8441 3.46072 6.89952 3.53039 6.96936L11.9994 15.4399L20.4684 6.96936C20.5381 6.89963 20.6209 6.84432 20.712 6.80658C20.8031 6.76884 20.9008 6.74942 20.9994 6.74942C21.098 6.74942 21.1957 6.76884 21.2868 6.80658C21.3779 6.84432 21.4607 6.89963 21.5304 6.96936C21.6001 7.0391 21.6554 7.12188 21.6932 7.21299C21.7309 7.3041 21.7503 7.40175 21.7503 7.50036C21.7503 7.59898 21.7309 7.69663 21.6932 7.78774C21.6554 7.87885 21.6001 7.96163 21.5304 8.03136L12.5304 17.0314C12.4607 17.1012 12.378 17.1566 12.2868 17.1944C12.1957 17.2322 12.098 17.2517 11.9994 17.2517C11.9007 17.2517 11.8031 17.2322 11.7119 17.1944C11.6208 17.1566 11.5381 17.1012 11.4684 17.0314L2.46839 8.03136C2.39854 7.9617 2.34313 7.87893 2.30532 7.78781C2.26751 7.6967 2.24805 7.59901 2.24805 7.50036C2.24805 7.40171 2.26751 7.30403 2.30532 7.21291C2.34313 7.1218 2.39854 7.03903 2.46839 6.96936Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulateDropdown);
export default __webpack_public_path__ + "static/media/simulate_dropdown.7b7750aa6ce33d560c9168045e7a5531.svg";
export { ForwardRef as ReactComponent };